import React from "react";
import { Modal} from "antd";
import { URL_POND } from "../../constants/urls";
import ErrorMessages from "../../common/ErrorMessages";
import ColorButton from "../../common/ColorButton";
import TSTable from "../../common/TSTable";
import { dateTimeToHumanString } from "../../frameworks/Util";
import _ from "lodash";
import { POND_ACTION, POND_STATUS, POND_STATUS_TH } from "../../constants/string";
import { POST } from "../../frameworks/HttpClient";

export default function PondStatusLogModal(props) {
  const { open, onClose, target, onUpdate } = props;
  const [ errorMessage, setErrorMessage ] = React.useState();
  const tableRef = React.useRef();

  const columns = [
    {
      title: 'วัน - เวลา',
      dataIndex: 'created',
      key: 'created',
      render : (value) => dateTimeToHumanString(value),
      width: 180,
    },
    {
      title: 'ผู้บันทึก',
      dataIndex: 'created_by_name',
      key: 'created_by_name',
    },
    {
      title: 'หมายเหตุ', 
      dataIndex: '',
      key: 'note',
      render : (_, original) => {
        return original ? `${POND_STATUS_TH[original.original_state]} -> ${POND_STATUS_TH[original.new_state]}` : "-"
      }      
    },
    {
      title: 'Action',
      dataIndex: '',
      key: 'action',
      render : (_, original, index) => {
        return index == 0 & (original.new_state !== POND_STATUS.FILLING) ? <a onClick={() => handleRevert()}>ย้อนกลับ</a> : ''
      }      
    },
  ]

  const refreshData = async() => {
    if(tableRef.current)(
      await tableRef.current.fetchWithoutResetPage()
    )
  }

  const handleRevert = async() => {
    try {
      await POST(`${URL_POND.POND_TRANSACTION}${target}/change-state/`, {action : POND_ACTION.REVERT})
      onUpdate();
      refreshData();
    } catch (error) {
      setErrorMessage(error.setErrorMessage);
    }
  }

  React.useState(() => {
    if(target){
      refreshData();
    }
  },[target])

  React.useEffect(() => {
    setErrorMessage(null)
  },[open])

  return(
    <Modal
      title={<center>ประวัติเปลี่ยนสถานะ</center>}
      open={open}
      onCancel={onClose}
      width={700}
      destroyOnClose
      footer={[
        <>
        <ColorButton onClick={onClose}>ปิด</ColorButton>
        </>
      ]}
    >
      <ErrorMessages message={errorMessage}/>
      <TSTable
        ref={tableRef}
        columns={columns}
        size={'small'}
        url={URL_POND.POND_TRANSACTION_STATE_LOG}
        params={{pond_transaction : target}}
      />
    </Modal>
  )
}